<template>
    <div class="cc-step">
        <div class="cc-content cc-content--errors" v-if="hasLoginCountryMismatchError">
            <div class="cc-alert cc-alert--error cc-alert--with-background">{{ translations['You have selected delivery country which is different than delivery country selected in your account. Please choose new carrier and payment type, or select another country if needed.'] }}</div>
        </div>
        <div class="cc-content cc-content--country">
            <country/>
        </div>
        <div class="cc-content cc-content--carriers">
            <carriers/>
        </div>
        <div class="cc-content cc-content--payments">
            <payments/>
        </div>
        <div class="cc-content cc-content--controls">
            <div class="cc-step-controls">
                <div class="cc-step-controls__section cc-step-controls__section--left">
                    <a href="javascript:void(0);" class="cc-button cc-button--blue" @click="$emit('setActiveStep', activeStep - 1)">{{ translations['Backward'] }}</a>
                </div>
                <div class="cc-step-controls__section cc-step-controls__section--right">
                    <a href="javascript:void(0);" class="cc-button cc-button--orange" @click="$emit('setActiveStep', activeStep + 1)">{{ translations['Forward'] }}</a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState} from "vuex";

    import Carriers from "./Carriers";
    import Country from "./Country";
    import Payments from "./Payments";

    export default {
        components: {
            Carriers,
            Country,
            Payments,
        },
        computed: {
            ...mapState({
                translations: state => state.translations,
                activeStep: state => state.activeStep,
                hasLoginCountryMismatchError: state => state.errors.loginCountryMismatch,
            }),
        },
        name: 'Step2',
    };
</script>

<style lang="scss" scoped="scoped">
    @import "./scss/main";

    #app {
        .cc-content {
            display: block;
            width: 100%;
            max-width: 100%;

            &.cc-content--errors {
                margin-top: 5rem;
            }

            &.cc-content--country {
                margin-top: 5rem;
            }

            &.cc-content--carriers {
                margin-top: 5rem;
            }

            &.cc-content--payments {
                margin-top: 5rem;
            }

            &.cc-content--controls {
                margin-top: 5rem;
            }
        }
    }
</style>
